import PB1 from '../_contentnew/palletsnew/pb1.webp'
import PB2B from '../_contentnew/palletsnew/pb2.webp'
import PB3 from '../_contentnew/palletsnew/pb3.webp'
import WingedPallet from '../_contentnew/palletsnew/winged.webp'

import HeavyStrapped from '../_contentnew/pallets/Heavy.webp'
import LightStrapped from '../_contentnew/pallets/Light-Strapped.webp'
import HeavyLegged from '../_contentnew/palletsnew/heavylegged.webp'

import FSEuroA from '../_contentnew/palletsnew/euroa.webp'
import FSEuroB from '../_contentnew/palletsnew/eurob.webp'
import MixedEuroHeavy from '../_contentnew/palletsnew/euromixedheavy.webp'
import MixedEuroLightMedium from '../_contentnew/palletsnew/euromixedlight.webp'

import CP7Image from '../_contentnew/palletsnew/cp7.webp'
import CP3Image from '../_contentnew/palletsnew/cp3.webp'

import PlasticImage from '../_contentnew/palletsnew/plastic.webp'

import PrintPallet from '../_contentnew/pallets/Print.webp'
import YankeeImage from '../_contentnew/palletsnew/yankee.webp'
import DrumPallet from '../_contentnew/palletsnew/drum.webp'
import MixedPrintPallet from '../_contentnew/pallets/Mixed-Print.webp'

import TwoWayPallet from '../_contentnew/pallets/2-Way-Pallet.webp'
import TwoWayAgricultural from '../_contentnew/pallets/2-Way-Agricultural.webp'

import EuroPalletCollar from '../_contentnew/palletsnew/eurocollar.webp'
import UKPalletCollar from '../_contentnew/palletsnew/ukcollar.webp'

export const pallets = [
  {
    id: 1,
    name: 'PB1 Grade A',
    category: 'UK Standard Pallets',
    dimensions: '1200 x 1000mm',
    weight: '24kg',
    loadCapacity: '1000kg',
    price: '£8.50',
    featured: true,
    description: 'Heavy-duty block perimeter base pallet suitable for demanding storage and transportation requirements.',
    image: PB1,
  },
  {
    id: 2,
    name: 'PB2 Grade B',
    category: 'UK Standard Pallets',
    dimensions: '1200 x 1000mm',
    weight: '24kg',
    loadCapacity: '1000kg',
    price: '£7.50',
    featured: false,
    description: 'Grade B heavy-duty block perimeter base pallet offering excellent value.',
    image: PB2B,
  },
  {
    id: 3,
    name: 'PB3',
    category: 'UK Standard Pallets',
    dimensions: '1200 x 1000mm',
    weight: '14kg',
    loadCapacity: '750kg',
    price: '£6.50',
    featured: true,
    description: 'Medium-duty block perimeter base pallet for general applications.',
    image: PB3,
  },
  {
    id: 4,
    name: 'Winged',
    category: 'UK Standard Pallets',
    dimensions: '1200 x 1000mm',
    weight: '20kg',
    loadCapacity: '750kg',
    price: '£5.50',
    featured: false,
    description: 'Winged pallet with top board overhang on two or four sides.',
    image: WingedPallet,
  },
  {
    id: 5,
    name: 'Heavy Strapped',
    category: 'UK Standard Pallets',
    dimensions: '1200 x 1000mm',
    weight: '24kg',
    loadCapacity: '1000kg',
    price: '£6.50',
    featured: false,
    description: 'Heavy strapped pallet reinforced on the underside.',
    image: HeavyStrapped,
  },
  {
    id: 6,
    name: 'Light Strapped',
    category: 'UK Standard Pallets',
    dimensions: '1200 x 1000mm',
    weight: '11kg',
    loadCapacity: '500kg',
    price: '£5.00',
    featured: false,
    description: 'Lightweight strapped pallet suitable for lighter loads.',
    image: LightStrapped,
  },
  {
    id: 7,
    name: 'Heavy Legged',
    category: 'UK Standard Pallets',
    dimensions: '1200 x 1000mm',
    weight: '18kg',
    loadCapacity: '1000kg',
    price: '£6.50',
    featured: false,
    description: 'Heavy-duty legged pallet open on two sides.',
    image: HeavyLegged,
  },
  {
    id: 8,
    name: 'F/S Euro-A',
    category: 'Euro Pallets',
    dimensions: '1200 x 800mm',
    weight: '21kg',
    loadCapacity: '1000kg',
    price: '£13.00',
    featured: true,
    description: 'Grade A full specification Euro pallet.',
    image: FSEuroA,
  },
  {
    id: 9,
    name: 'F/S Euro-B',
    category: 'Euro Pallets',
    dimensions: '1200 x 800mm',
    weight: '21kg',
    loadCapacity: '1000kg',
    price: '£11.00',
    featured: false,
    description: 'Grade B full specification Euro pallet.',
    image: FSEuroB,
  },
  {
    id: 10,
    name: 'Mixed Euro - Heavy',
    category: 'Euro Pallets',
    dimensions: '1200 x 800mm',
    weight: '12kg',
    loadCapacity: '750kg',
    price: '£5.50',
    featured: false,
    description: 'Heavy mixed-grade Euro pallet.',
    image: MixedEuroHeavy,
  },
  {
    id: 11,
    name: 'Mixed Euro - Light-Medium',
    category: 'Euro Pallets',
    dimensions: '1200 x 800mm',
    weight: '10kg',
    loadCapacity: '250kg',
    price: '£4.75',
    featured: false,
    description: 'Light to medium-duty mixed Euro pallet.',
    image: MixedEuroLightMedium,
  },
  {
    id: 12,
    name: 'CP7',
    category: 'CP Pallets',
    dimensions: '1150 x 1350mm',
    weight: '22kg',
    loadCapacity: '1000kg',
    price: '£8.00',
    featured: true,
    description: 'CP7 pallet with top board overhang on all four sides.',
    image: CP7Image,
  },
  {
    id: 13,
    name: 'CP3',
    category: 'CP Pallets',
    dimensions: '1140 x 1140mm',
    weight: '20kg',
    loadCapacity: '1000kg',
    price: '£6.50',
    featured: false,
    description: 'CP3 pallet with top board overhang on two sides.',
    image: CP3Image,
  },
  {
    id: 14,
    name: 'Plastic',
    category: 'Plastic Pallets',
    dimensions: 'Various Sizes',
    weight: '10kg - 20kg',
    loadCapacity: '500kg - 1000kg',
    price: '£11.00 - £21.00',
    featured: false,
    description: 'Mixed plastic pallets available in various sizes and capacities.',
    image: PlasticImage,
  },
  {
    id: 15,
    name: 'Print Pallet',
    category: 'Specialist Pallets',
    dimensions: '800 x 600mm',
    weight: '8kg',
    loadCapacity: '500kg',
    price: '£6.00',
    featured: false,
    description: 'Compact pallet commonly used in printing and packaging industries.',
    image: PrintPallet,
  },
  {
    id: 16,
    name: 'Yankee',
    category: 'Specialist Pallets',
    dimensions: '1200 x 1000mm',
    weight: '20kg',
    loadCapacity: '750kg - 1000kg',
    price: '£5.00',
    featured: false,
    description: 'American-style pallet with fork slots on all sides.',
    image: YankeeImage,
  },
  {
    id: 17,
    name: 'Drum Pallet',
    category: 'Specialist Pallets',
    dimensions: '1200 x 1200mm',
    weight: '24kg',
    loadCapacity: '1000kg',
    price: '£9.00',
    featured: false,
    description: 'Heavy-duty pallet designed for drums and larger loads.',
    image: DrumPallet,
  },
  {
    id: 18,
    name: 'Mixed Print Pallet',
    category: 'Specialist Pallets',
    dimensions: '600-750mm x 800-950mm',
    weight: '8kg',
    loadCapacity: '400kg',
    price: '£5.00',
    featured: false,
    description: 'Mixed-size print pallet suitable for lighter applications.',
    image: MixedPrintPallet,
  },
  {
    id: 19,
    name: '2-Way Pallet',
    category: 'Specialist Pallets',
    dimensions: '1200 x 1000mm',
    weight: '14kg',
    loadCapacity: '1000kg',
    price: '£5.00',
    featured: false,
    description: 'Traditional 2-way strapped pallet.',
    image: TwoWayPallet,
  },
  {
    id: 20,
    name: '2-Way Agricultural',
    category: 'Agricultural Pallets',
    dimensions: '1500 x 1200mm',
    weight: '22kg',
    loadCapacity: '1000kg',
    price: '£11.00',
    featured: false,
    description: 'Large agricultural pallet suitable for heavier loads.',
    image: TwoWayAgricultural,
  },
  {
    id: 21,
    name: 'Euro Pallet Collar',
    category: 'Pallet Collars',
    dimensions: '1200 x 800 x 190mm',
    price: '£9.00',
    featured: false,
    description: 'Collar designed to stack on a standard Euro pallet.',
    image: EuroPalletCollar,
  },
  {
    id: 22,
    name: 'UK Pallet Collar',
    category: 'Pallet Collars',
    dimensions: '1200 x 1000 x 190mm',
    price: '£11.00',
    featured: false,
    description: 'Collar designed to stack on a standard UK pallet.',
    image: UKPalletCollar,
  },
]